<template>
  <div class="passo2">
    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para sua empresa</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m6 timeline-icon two active">2</div>
          <div class="marker mlast timeline-icon three">3</div>
        </div>
      </div>
    </div>


    <div class="container wp-box section section-artigo with-box">
      
      <div class="row">
        <div class="colsm-12">
          <p>Para que a Caixa possa contribuir para a saúde financeira da sua empresa, é importante que você responda às perguntas abaixo.</p>
        </div>
      </div>
      
      <div class="form-passos">
        <div class="row">
          <div class="colsm-4">
            <div class="control-item">
              <label class="label-d">Seu faturamento declarado anual é de (R$):</label>
              <money :value="dados.mFaturamento_Anual" v-model="dados.mFaturamento_Anual" name="faturamento" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('faturamento') }} </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Optante pelo SIMPLES:</label>
              <input type="radio" name="gestao-empresa" v-model="dados.bE_Optante_Simples" value="true" class="font-icon" checked="checked"><span class="opcao-radio">Sim</span> 
              <input type="radio" name="gestao-empresa" v-model="dados.bE_Optante_Simples" value="false" class="font-icon"><span class="opcao-radio">Não</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Você é Microempreendedor Individual (MEI)?</label>
              <input type="radio" name="mei" v-model="dados.segmento" value="true" class="font-icon" checked="checked"><span class="opcao-radio">Sim</span> 
              <input type="radio" name="mei" v-model="dados.segmento" value="false" class="font-icon"><span class="opcao-radio">Não</span>
            </div>
          </div>
        </div>

        <div class="row" >
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Informe a média de despesas mensais com:</label>
            </div>
          </div>
        </div>

         <div class="row">
           <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Valor da folha (R$):</label>
              <money :value="dados.mValor_Folha_Pagamento" v-model="dados.mValor_Folha_Pagamento" name="folha" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('folha') }} </small>
            </div>
          </div>
          
          <div class="colsm-1"></div>

          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Número de empregados:</label>
              <input type="text" name="empregados" v-validate="'required'" v-mask="'###.###.###'" v-model="dados.iQuantidade_Empregados" value placeholder="000.000" class="field-d" maxlength="50"/>
              <small class="form-text text-muted">{{ errors.first('empregados') }} </small>
            </div>
          </div>
          
        </div>

         <div class="row" style="margin-top: -20px;">
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Aluguel (R$):</label>
              <money :value="dados.mGasto_Aluguel" v-model="dados.mGasto_Aluguel" name="aluguel" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('aluguel') }} </small>
            </div>
          </div>
          <div class="colsm-1"></div>
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Água, luz, telefone (R$):</label>
              <money :value="dados.mGasto_Agua_Luz_Telefone" v-model="dados.mGasto_Agua_Luz_Telefone"  name="agua" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('agua') }} </small>
            </div>
          </div>
          <div class="colsm-1"></div>
          <div class="colsm-2">
            <div class="control-item">
              <label class="label-d">Fornecedores (R$):</label>
              <money :value="dados.mGasto_Fornecedores" v-model="dados.mGasto_Fornecedores" name="fornecedores" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('fornecedores') }} </small>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="colsm-4">
            <div class="control-item">
              <label class="label-d">E está precisando de um crédito no valor de (R$):</label>
              <money name="valorEmprestimo" :value="dados.mNecessidade_Valor" v-model="dados.mNecessidade_Valor" class="field-d" v-bind="money" placeholder="0,00" v-validate="'required'"></money>
              <small class="form-text text-muted">{{ errors.first('valorEmprestimo') }} </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Forma de recebimento das vendas:</label>
            </div>
          </div>
        </div>


        <div class="row" style="margin-top: -40px;">
          <div class="colsm-7 slider-valores">
            <div class="control-item">
              <label class="label-d espacamento-label"><input type="checkbox" class="form-check-input" name="" id="" v-model="checkCartao" value="true"> Cartão</label>
                <vue-slider :min="0" :lazy="true" :disabled="!checkCartao" :tooltip="'always'" :data="['0% a 20%', '20% a 40%', '40% a 60%', '60% a 80%', '80% a 100%']" :marks="marks" :dotSize="5" v-model="cartao">
                  <template v-slot:tooltip="{ value, focus }">
                    <div :class="['custom-tooltip', { focus }]"> {{value}}</div>
                  </template>
                </vue-slider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-7 slider-valores">
            <div class="control-item">
              <label class="label-d espacamento-label"><input type="checkbox" class="form-check-input" name="" id="" v-model="checkBoleto" value="true"> Boleto</label>
                <vue-slider :min="0" :lazy="true" :disabled="!checkBoleto" :tooltip="'always'" :data="['0% a 20%', '20% a 40%', '40% a 60%', '60% a 80%', '80% a 100%']" :marks="marks" :dotSize="5" v-model="boleto">
                  <template v-slot:tooltip="{ value, focus }">
                    <div :class="['custom-tooltip', { focus }]"> {{value}}</div>
                  </template>
                </vue-slider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-7 slider-valores">
            <div class="control-item">
              <label class="label-d espacamento-label"><input type="checkbox" class="form-check-input" name="" id="" v-model="checkDinheiro" value="true"> Dinheiro / Crédito em conta</label>
                <vue-slider :min="0" :lazy="true" :disabled="!checkDinheiro" :tooltip="'always'" :data="['0% a 20%', '20% a 40%', '40% a 60%', '60% a 80%', '80% a 100%']" :marks="marks" :dotSize="5" v-model="dinheiro">
                  <template v-slot:tooltip="{ value, focus }">
                    <div :class="['custom-tooltip', { focus }]"> {{value}}</div>
                  </template>
                </vue-slider>
            </div>
          </div>
        </div>


        <div class="row" style="margin-top: 40px;">
          <div class="colsm-8">
            <div class="control-item">
              <label class="label-d">Gestão financeira da empresa:</label>
              <input type="radio" name="gestao-empresa" v-model="dados.vGestao_Financeira_Empresa" value="Regular" class="font-icon" checked="checked"><span class="opcao-radio">Regular</span> 
              <input type="radio" name="gestao-empresa" v-model="dados.vGestao_Financeira_Empresa" value="Boa" class="font-icon"><span class="opcao-radio">Boa</span>
              <input type="radio" name="gestao-empresa" v-model="dados.vGestao_Financeira_Empresa" value="Ótima" class="font-icon"><span class="opcao-radio">Ótima</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <small class="form-text text-muted" v-if="erroApi">Erro de comunicação com o servidor. Tente novamente mais tarde.</small>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <a class="btn blue" @click="validarAvancar(dados)">Próxima Etapa</a> <span class="etapa-anterior">ou <router-link :to="{name: 'passo-um-pj', params: {dados}}" >volte à etapa anterior</router-link></span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>

import axios from 'axios';
import {Money} from 'v-money'

export default {
  components: {Money},
  name: 'passo2pj',
  data: function() {
    return {
      faturamento: 0,
      valorEmprestimo: 0,
      empregados: 0,
      folha: 0,
      aluguel: 0,
      fornecedores: 0,
      agua: 0,
      segmento: false,
      marks: {
        '0% a 20%': {
          label: '0% a 20%',
          labelStyle: {
            fontSize: '10px'
          }
        },
        '20% a 40%': {
          label: '20% a 40%',
          labelStyle: {
            fontSize: '10px'
          }
        },
        '40% a 60%': {
          label: '40% a 60%',
          labelStyle: {
            fontSize: '10px'
          }
        },
        '60% a 80%': {
          label: '60% a 80%',
          labelStyle: {
            fontSize: '10px'
          }
        },
        '80% a 100%': {
          label: '80% a 100%',
          labelStyle: {
            fontSize: '10px'
          }
        }
      },
      cartao: '0% a 20%',
      boleto: '0% a 20%',
      dinheiro: '0% a 20%',
      checkCartao: false,
      checkBoleto: false,
      checkDinheiro: false,
      simples: false,
      gestaoEmpresa: '',
      dados: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      erroApi: false,
      urlApi: process.env.VUE_APP_URL_API
    };
  },
  methods: {
    validarAvancar(dados) {
      var _this = this;

      _this.dados.nPercentual_Recebimento_Cartao = ((_this.checkCartao) ? _this.cartao : null); 
      _this.dados.nPercentual_Recebimento_Boleto = ((_this.checkBoleto) ? _this.boleto : null); 
      _this.dados.nPercentual_Recebimento_Dinheiro = ((_this.checkDinheiro) ? _this.dinheiro : null); 

      _this.dados.iPasso_Simulador = 2;

      _this.$validator.validate().then(valid => {
        if (valid && _this.dados.iID_Visita) {
          this.$loading(true);
          axios.post(_this.urlApi + 'Visita_Dados_PJ/' + _this.dados.iID_Visita, _this.dados)
            .then(function (response) {

              try{
                dataLayer.push({
                  'passoSimulador': 'Passo2',
                  'event': 'proximoPasso',
                  'tipo': 'PJ'
                });
              } catch(error){
                console.error(error);
              }
              dados = response.data;

              _this.$router.push({name:'passo-tres-pj', params:{dados}});
              _this.$loading(false);
            })
            .catch(function (error) {
              _this.erroApi = true;
              _this.$loading(false);
            });
        }
      });

    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  created: function(){
    this.dados = this.$route.params.dados;

    if(this.dados.nPercentual_Recebimento_Cartao){
      this.checkCartao = true;
      this.cartao = this.dados.nPercentual_Recebimento_Cartao;
    }
    if(this.dados.nPercentual_Recebimento_Boleto){
      this.checkBoleto = true;
      this.boleto = this.dados.nPercentual_Recebimento_Boleto;
    }
    if(this.dados.nPercentual_Recebimento_Dinheiro){
      this.checkDinheiro = true;
      this.dinheiro = this.dados.nPercentual_Recebimento_Dinheiro;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



.custom-tooltip {
  position: relative;
	background: #F7941E;
  border-radius: 5px;
  color: #FFFFFF;
  padding: 5px;
  font-family: 'futura-lt-bold';
  font-size: 12px;
  width: 90px;
  text-align: center;
}
.custom-tooltip:after{
  	top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(247, 148, 30, 0);
    border-top-color: #F7941E;
    border-width: 6px;
    margin-left: -6px;
}
.espacamento-label{
  margin-bottom: 35px;
  margin-top: 20px;
}


/*  TABLET */
@media only screen and (max-width: 1026px) {

}

@media only screen and (max-width: 770px){


}
/* MOBILE */

/* IPHONE 6 PLUS*/
@media only screen and (max-width: 645px) {


}
/* IPHONE 6 */
@media only screen and (max-width: 480px) {
  .slider-valores{
    padding-left: 35px;
    padding-right: 35px;
  }
  .custom-tooltip {
    font-size: 9px;
    padding-left: 2px;
    padding-right: 2px;
    width: 60px;
  } 


}

/* IPHONE 5*/
@media only screen and (max-width: 328px) {

}


</style>